<template>
  <div class="animated fadeIn">     
    <b-row>
      <b-col md="12">
        <b-card>
          <div slot="header">
            <strong> Pickup Location(Vendors)</strong>
            <div class="card-header-actions" >  
            
            <!-- Code hide by Sachin
            Date: 30/12/2019   -->    


              <!-- <button class="btn btn-sm btn-primary mr-4 btn-pill" v-on:click="useradd()"  type="button">Add New</button>
              <button class="btn btn-sm btn-primary btn-pill" v-on:click="searchpickup()" type="button">Search</button>
               <button class="btn btn-sm btn-primary ml-4" v-on:click="refresh()" type="button"><i class="fa fa-refresh"></i></button> -->

               <!--End Code hide by Sachin
            Date: 30/12/2019   -->    

            </div>
          </div>
         
          <div class="box mb-2" id="adduser"  style="padding: .75rem 1.25rem;border: 1px solid rgba(0,0,0,.125);display:none;">
            <form @submit.prevent="validateForm('form-1')" data-vv-scope="form-1">
              <b-row>
                <b-col md="6" >  
                  <input type="hidden" name="clientid" id="clientid" value="27">                
                  <b-form-group label="Location Name" :label-cols="3"
                    >                  
                    <b-form-input v-on:keyup="clear1" type="text" v-model="customer.pickuplocationname" name="pickup location name" v-validate="'required|'" :class="{'input': true, 'text-danger': errors.has('form-1.pickup location name') }" placeholder="Enter Pickup Location Name">
                    </b-form-input>
                     <span style="text-align:left;" v-show="errors.has('form-1.pickup location name')" class="help text-danger">{{ errors.first('form-1.pickup location name') }}</span>
                  </b-form-group>
             
                  <b-form-group label="Location ID" :label-cols="3"
                    >   
                    <b-form-select v-model="customer.pickuplocationpincode" name="locationpincode" v-validate="'required'" :class="{'input': true, 'text-danger': errors.has('form-1.locationpincode') }">
                        <option :value="selected">--Select--</option>
                        <option v-for="state in states"  v-bind:value="state.locality_id">{{state.locality_name}}</option>
                    </b-form-select> 

                    
                    <span style="text-align:left;" v-show="errors.has('form-1.location pincode')" class="help text-danger">{{ errors.first('form-1.pickup location code') }}</span>        
                  </b-form-group>

                  <b-form-group label="State" :label-cols="3"
                    >                  
                  
                    <b-form-input  type="text" v-model="customer.pickuplocationstate" name="state" v-validate="'required|'" :class="{'input': true, 'text-danger': errors.has('form-1.state') }" placeholder="Enter  state">
                    </b-form-input>
                     <span style="text-align:left;" v-show="errors.has('form-1.state')" class="help text-danger">{{ errors.first('form-1.state') }}</span>   
                  </b-form-group>
                  
                  <b-form-group label="Address" :label-cols="3"
                    >                  
                     <b-form-textarea class="textarea" id="" v-model="customer.pickuplocationaddress" name="address" v-validate="'required'" :class="{'input': true, 'text-danger': errors.has('form-1.address') }" placeholder="Enter Address"></b-form-textarea>
                      <small v-if='pickuplocationaddress' class="error">please enter pickuplocation address</small> 
                      <span style="text-align:left;" v-show="errors.has('form-1.address')" class="help text-danger">{{ errors.first('form-1.address') }}</span>  
                  </b-form-group>

                  <b-form-group label="Landmark" :label-cols="3"
                    >                  
                    <b-form-input class="input" type="text" v-model="customer.pickuplocationlandmark" name="landmark" v-validate="'required|alpha_spaces'" :class="{'input': true, 'text-danger': errors.has('form-1.landmark') }" placeholder="Enter Landmark Name">
                   </b-form-input>
                    <span style="text-align:left;" v-show="errors.has('form-1.landmark')" class="help text-danger">{{ errors.first('form-1.landmark') }}</span>
                  </b-form-group>

                  <b-form-group label="POC Mobile Number" :label-cols="3"
                    >                  
                    <b-form-input class="input" type="text" id="mobilenumber" v-model="customer.pocmobilenumber" name="poc mobile number" maxlength="10" v-validate="'required|digits:10'" :class="{'input': true, 'text-danger': errors.has('form-1.poc mobile number') }" placeholder="Enter POC Mobile Number">
                   </b-form-input>
                    <span style="text-align:left;" v-show="errors.has('form-1.poc mobile number')" class="help text-danger">{{ errors.first('form-1.poc mobile number') }}</span>
                  </b-form-group>
                 
                  <b-form-group label="Verification Code" :label-cols="3"
                    >                  
                    <b-form-input class="input" type="text" v-model="customer.verificationcode" name="verification code" v-validate="'required'" :class="{'input': true, 'text-danger': errors.has('form-1.verification code') }" placeholder="Enter Verification Code">
                   </b-form-input>
                     <span style="text-align:left;" v-show="errors.has('form-1.verification code')" class="help text-danger">{{ errors.first('form-1.verification code') }}</span>
                  </b-form-group>

                  <b-form-group label="Latitude" :label-cols="3"
                    >                  
                    <b-form-input class="input" type="text" v-model="latitude" name="latitude" v-validate="'decimal'" :class="{'input': true, 'text-danger': errors.has('form-1.latitude') }" placeholder="Enter Latitude">
                    </b-form-input>
                    <span style="text-align:left;" v-show="errors.has('form-1.latitude')" class="help text-danger">{{ errors.first('form-1.latitude') }}</span>
                  </b-form-group>
                </b-col>  
                <b-col md="6" >
                 
                  <b-form-group label="Location Code" :label-cols="3"
                    >                  
                    <b-form-input class="input" type="text" v-model="customer.pickuplocationcode" name="pickup location code" v-validate="'required|alpha_num'" :class="{'input': true, 'text-danger': errors.has('form-1.pickup location code') }" placeholder="Enter Pickup Location Code">
                    </b-form-input>
                    <span style="text-align:left;" v-show="errors.has('form-1.pickup location code')" class="help text-danger">{{ errors.first('form-1.pickup location code') }}</span>
                  </b-form-group>

                  <b-form-group label="Location Type" :label-cols="3"
                    >    
                     <input type="text" readonly='' name="pickuplocationtype" id="pickuplocationtype" value="P2P" class="form-control input">               
                   <!--  <b-form-select name="location type" v-model="customer.pickuplocationtype" v-validate="'required'" :class="{'input': true, 'text-danger': errors.has('form-1.location type') }" style="margin-left:-0px;">
                      <option :value="selected">--Select--</option>
                      <option value="p2p">P2P</option>
                      <option value="p2phub">P2P Hub</option>
                    </b-form-select> -->
                    
                  </b-form-group>

                  <b-form-group label="City" :label-cols="3"
                    >                  
                  <b-form-input class="input" type="text" v-model="customer.pickuplocationcity" name="city" v-validate="'required|alpha_spaces'" :class="{'input': true, 'text-danger': errors.has('form-1.city') }" placeholder="Enter City Name">
                  </b-form-input>
                    <span style="text-align:left;" v-show="errors.has('form-1.city')" class="help text-danger">{{ errors.first('form-1.city') }}</span>
                  </b-form-group>

                  <b-form-group label="Street" :label-cols="3"
                    >                  
                  <b-form-input class="input" type="text" v-model="customer.pickuplocationstreet" name="street" v-validate="'required'" :class="{'input': true, 'text-danger': errors.has('form-1.street') }" placeholder="Enter Street Name">
                 </b-form-input>
                   <span style="text-align:left;" v-show="errors.has('form-1.street')" class="help text-danger">{{ errors.first('form-1.street') }}</span>
                  </b-form-group>

                  <b-form-group label="POC Name" :label-cols="3"
                    >                  
                   <b-form-input class="input" type="text" v-model="customer.pocname" name="poc name" v-validate="'required|'" :class="{'input': true, 'text-danger': errors.has('form-1.poc name') }" placeholder="Enter POC Name">
                   </b-form-input>
                   <span style="text-align:left;" v-show="errors.has('form-1.poc name')" class="help text-danger">{{ errors.first('form-1.poc name') }}</span>
                  </b-form-group>

                  <b-form-group label="POC Alt Mobile Number" :label-cols="3"
                    >                  
                  <b-form-input class="input" type="text" v-model="customer.pickuplocationpocmobilenoalt" name="pickuplocationpocmobilenoalt" maxlength="10" placeholder="Enter Pickup Location POC Alternate Mobile No">
                  </b-form-input>
                   <span style="text-align:left;" v-show="errors.has('form-1.poc name')" class="help text-danger">{{ errors.first('form-1.poc name') }}</span>
                  </b-form-group>

                  <b-form-group label="Vendor Code" :label-cols="3"
                    >                  
                  <b-form-input class="input" type="text" v-model="customer.clientvendorcode" name="client vendor code" v-validate="'required'" :class="{'input': true, 'text-danger': errors.has('form-1.client vendor code') }" placeholder="Enter Client Vendor Code">
                   </b-form-input>
                   <span style="text-align:left;" v-show="errors.has('form-1.client vendor code')" class="help text-danger">{{ errors.first('form-1.client vendor code') }}</span>
                  </b-form-group>

                  <b-form-group label="Longitude" :label-cols="3"
                    >                  
                  <b-form-input class="input" type="text" v-model="longitude" name="longitude" v-validate="'decimal'" :class="{'input': true, 'text-danger': errors.has('form-1.longitude') }" placeholder="Enter Longitude">
                   </b-form-input>
                    <span style="text-align:left;" v-show="errors.has('form-1.longitude')" class="help text-danger">{{ errors.first('form-1.longitude') }}</span>
                  </b-form-group>     

                     <b-form-group label="IsActive" :label-cols="3"
                    >                  
                  <b-form-select name="isactive" v-model="customer.isactive" v-validate="'required'" :class="{'input': true, 'text-danger': errors.has('form-1.isactive') }">
                    <option :value="selected">--Select--</option>
                    <option value="1">Active</option>
                    <option value="0">InActive</option>
                  </b-form-select>
                  <span style="text-align:left;" v-show="errors.has('form-1.isactive')" class="help text-danger">{{ errors.first('form-1.isactive') }}</span>
                  </b-form-group>             
                </b-col>  
              </b-row>
              <div slot="footer" class="text-right">
                <b-button type="submit" class="mr-2" size="md" variant="primary"> Submit</b-button>
                <b-button type="button" size="md" variant="danger" @click="clear">Reset</b-button>
              </div>             
            </form>
          </div>
          <div class="box mb-2" id="searchpickup"  style="padding: .75rem 1.25rem;border: 1px solid rgba(0,0,0,.125);display:none;">
            <form @submit.prevent="validateForm2('form-2')" data-vv-scope="form-2">
              <b-row>
                <b-col sm="3">

                  <b-form-group>
                  <label for="Client">Client</label>
                   <b-form-select name="client" v-model="customerSearch.clientid" class="mySelectBox">
                        <option :value="selected">--Select--</option>
                        <option :value="cdata.clientmasterid" v-for="cdata in clientdata">{{ cdata.clientname }}</option>
                    </b-form-select>
                  </b-form-group>
                </b-col>
             
                <b-col sm="3">
                  <b-form-group>
                    <label for="ccnumber">Location Type</label>
                    <b-form-select name="location type" v-model="customerSearch.pickuplocationtype" v-validate="'required'" class="mySelectBox">
                        <option :value="selected">--Select--</option>
                        <option value="p2p">P2P</option>
                        <option value="p2phub">P2P Hub</option>
                    </b-form-select>
                  </b-form-group>
                </b-col>

                <b-col sm="3">
                  <b-form-group>
                  <label >Pickup Location Code</label>
                     <b-form-input class="input" type="text" name="Code" v-model="customerSearch.pickuplocationcode" placeholder="Enter Pickup Location Code">
                   </b-form-input>
                  </b-form-group>
                </b-col>
             
                <b-col sm="3">
                  <b-form-group>
                    <label >Pickup Location Name</label>
                    <b-form-input class="input" type="text" name="Location" v-model="customerSearch.pickuplocationname" placeholder="Enter Pickup Location Name">
                    </b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col sm="3">
                  <b-form-group>
                    <label>State</label>
                     <b-form-input class="input" type="text" name="state" v-model="customerSearch.pickuplocationstate" placeholder="Enter State">
                     </b-form-input>
                  </b-form-group>
                </b-col> 
                <b-col sm="3">
                  <b-form-group>
                    <label>IsActive</label>
                      <b-form-select name="isactive" v-model="customerSearch.isactive" class="mySelectBox">
                          <option :value="selected">--Select--</option>
                          <option value="1">true</option>
                          <option value="0">false</option>
                      </b-form-select>
                  </b-form-group>
                </b-col> 

                <b-col sm="3">
                  <b-form-group>
                    <label>City</label>
                     <b-form-input class="input" type="text" name="city" v-model="customerSearch.pickuplocationcity" placeholder="Enter City">
                     </b-form-input>
                  </b-form-group>
                </b-col>        
               
               <b-col sm="3">
                  <b-form-group>
                    <label>Pickup Location ID</label>
                      <b-form-input class="input" type="text" name="pickuplocationpincode" v-model="customerSearch.pickuplocationpincode" placeholder="Enter Pickup Location ID ">
                     </b-form-input>
                  </b-form-group>
                </b-col>                
              </b-row>
              <div slot="footer" class="text-right">
                <b-button type="submit" size="md" class="mr-2" variant="primary">Submit</b-button>
                <b-button type="button" size="md" variant="danger" @click="searchclear">Clear</b-button>
              </div> 
              
            </form>
          </div>     
          <b-row class="mb-4"> 
          <b-col md="4" class="my-1">
            <b-col md="12">
                <b-form-group >
                  
                    <b-form-input v-model="searching" placeholder="Type to Search"></b-form-input>
                   
                     
                </b-form-group>
              </b-col>
              </b-col>   
                <b-col md="1" class="my-1">
                <b-form-group >
                  
                    
                   
                      <b-button v-on:click="displaydata(1)">Search</b-button>
                  
                  
                </b-form-group>
              </b-col>   
                <b-col md="1" class="my-1">
                <b-form-group >
                  
                   
                      <b-button v-on:click="clearrecord">Clear</b-button>
                  
                </b-form-group>
              </b-col>         
              <!-- <b-col md="4" class="my-1">
                <b-form-group label-cols-sm="3" label="Filter" class="mb-0">
                  <b-input-group>
                    <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
                    <b-input-group-append>
                      <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col md="4" class="my-1">
                <b-form-group label-cols-sm="3" label="Sort" class="mb-0">
                  <b-input-group>
                    <b-form-select v-model="sortBy" :options="sortOptions">
                      <option slot="first" :value="null">-- none --</option>
                    </b-form-select>
                    <b-form-select v-model="sortDesc" :disabled="!sortBy" slot="append">
                      <option :value="false">Asc</option> <option :value="true">Desc</option>
                    </b-form-select>
                  </b-input-group>
                </b-form-group>
              </b-col>             --> 
             <!--  <b-col md="4" class="my-1">
                <b-form-group label-cols-sm="3" label="Per page" class="mb-0">
                  <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                </b-form-group>
              </b-col> -->  
               <b-col sm="12" class="text-right">
                <b-col sm="12">  
               <p > <b>Total Records :<span style="color:red;">{{ this.totalRows }}</span></b> </p>
             </b-col>
              </b-col>          
          </b-row> 
          <b-col sm="12">  
          <b-table show-empty stacked="md"  :items="items" :busy="isBusy"  :fields="fields"  :current-page="currentPage"  :per-page="perPage"  :filter="filter"   :sort-by.sync="sortBy"  :sort-desc.sync="sortDesc"   :sort-direction="sortDirection"    @filtered="onFiltered"    :bordered="bordered" > 

            <div slot="table-busy" class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Loading...</strong>
            </div>  

            <template slot="isactive" slot-scope="row">
               <span data-toggle="tooltip" title="InActive" v-if="row.value.isactive ==='0'" style="color:red"> <i class="badge badge-success">In Active</i></span>
              <span data-toggle="tooltip" title="Active" v-else style="color:green"><i class="badge badge-success">Active</i></span>
            </template>
            <template slot="show_details" slot-scope="row">
             <!--  <b-button size="sm" @click="info(row.item, row.index, $event.target)" class="mr-1">
                    Edit
              </b-button> -->
              <b-button size="sm" @click="row.toggleDetails" class="mr-2" v-on:click="getlocations()" style="background: #b0c4de !important;color: #000 !important;">
                {{ row.detailsShowing ? 'Hide' : 'Show'}} Details
              </b-button>
            </template>
            <template slot="row-details" slot-scope="row">
              <b-card>
                <b-row>
                  <b-col sm="6">

                    <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b> Id:</b></b-col>
                      <b-col>{{ row.item.pickuplocationmasterid }}</b-col>
                    </b-row>

                    <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b>Location Name:</b></b-col>
                      <b-col>{{ row.item.pickuplocationname }}</b-col>
                    </b-row>

                    <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b>Location Type:</b></b-col>
                      <b-col>{{ row.item.pickuplocationtype }}</b-col>
                    </b-row>

                    <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b> Address:</b></b-col>
                      <b-col>{{ row.item.pickuplocationaddress }}</b-col>
                    </b-row>

                    <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b> Country:</b></b-col>
                      <b-col>{{ row.item.pickuplocationcountry }}</b-col>
                    </b-row>

                    <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b> State:</b></b-col>
                      <b-col>{{ row.item.pickuplocationstate }}</b-col>
                    </b-row>

                    <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b>City:</b></b-col>
                      <b-col>{{ row.item.pickuplocationcity }}</b-col>
                    </b-row>

                    <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b>Street:</b></b-col>
                      <b-col>{{ row.item.pickuplocationstreet }}</b-col>
                    </b-row>

                    <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b>Landmark:</b></b-col>
                      <b-col>{{ row.item.pickuplocationlandmark ? row.item.pickuplocationlandmark:'-' }}</b-col>
                    </b-row>

                     <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b>Location Id:</b></b-col>
                      <b-col>{{ row.item.pickuplocationpincode ? row.item.pickuplocationpincode:'-' }}</b-col>
                    </b-row>

                    <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b>Status:</b></b-col>
                      <b-col>{{ row.item.isactive==1 ? 'Active':'In active' }}</b-col>
                    </b-row>
                     
                    
                    
                  </b-col>  
                  <b-col sm="6">
                   
                    <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b>Poc Name:</b></b-col>
                      <b-col>{{ row.item.pocname ? row.item.pocname:'-' }}</b-col>
                    </b-row>
                    <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b>Mobile Number:</b></b-col>
                      <b-col>{{ row.item.pocmobilenumber ? row.item.pocmobilenumber:'-' }}</b-col>
                    </b-row>
                    <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b>Mobile No Alt:</b></b-col>
                      <b-col>{{ row.item.pickuplocationpocmobilenoalt ? row.item.pickuplocationpocmobilenoalt:'-' }}</b-col>
                    </b-row>
                    <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b>Created Date:</b></b-col>
                      <b-col>{{ row.item.createddate | datechange}}</b-col>
                    </b-row>
                    <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b>Created By:</b></b-col>
                      <b-col>{{ row.item.createdby ? row.item.createdby:'-' }}</b-col>
                    </b-row>
                    <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b>Last Modified Date:</b></b-col>
                      <b-col> {{ row.item.lastmodifieddate| datechange }} </b-col>
                    </b-row>
                    <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b>Last Modified By:</b></b-col>
                      <b-col>{{ row.item.lastmodifiedby ? row.item.lastmodifiedby:'-' }}</b-col>
                    </b-row>
                    <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b>Verification Code:</b></b-col>
                      <b-col>{{ row.item.verificationcode ? row.item.verificationcode:'-' }}</b-col>
                    </b-row>

                    <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b>Client Vendor Code:</b></b-col>
                      <b-col>{{ row.item.clientvendorcode ? row.item.clientvendorcode:'-' }}</b-col>
                    </b-row>
                    <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b>Lat Long: </b></b-col>
                      <b-col>{{ row.item.pickuplonglat ? row.item.pickuplonglat:'-' }}</b-col>
                    </b-row>
                      <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b>Location Code:</b></b-col>
                      <b-col>{{ row.item.pickuplocationcode ? row.item.pickuplocationcode:'-' }}</b-col>
                    </b-row>
                    
                      
                                   
                   </b-col> 
                  <b-col sm="12">
                  <div slot="footer" class="text-right">
                   <b-button size="sm" @click="row.toggleDetails" style="background: #b0c4de !important;color: #000 !important;">Hide Details</b-button>
                  </div> 
                 </b-col> 
                </b-row> 

              </b-card>
            </template>
          </b-table>
        </b-col>
          <b-col md="12" class="my-1 " v-if="this.totalRows > 10">
           <!--  <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                class="my-0"
              >
            </b-pagination> -->
            <paginate
   
    :page-count="noofpages"
    :page-range="10"
    :margin-pages="2"
    :click-handler="clickCallback"
    :prev-text="'Prev'"
    :next-text="'Next'"
    :container-class="'pagination'"
    :page-class="'page-item'">
  </paginate>
          </b-col>    
        </b-card>
        <div class="modal" :class="{'is-active' : verificationCodeToggleInfo}">
          <form @submit.prevent="validateForm4('form-4')" data-vv-scope="form-4">
            <div class="modal-background"></div>
            <div class="modal-card">
              <header class="modal-card-head">
                <p class="modal-card-title">Change Verification Code</p>
                <button class="delete" type="button" @click="CloseVerificationCodeModal"></button>
              </header>
              <section class="modal-card-body">
                <div class="field">
                  <p class="control">
                    <input class="input" type="text" name="Verification Code" v-model="customer.verificationcode" v-validate="'required|'" :class="{'input': true, 'text-danger': errors.has('form-4.Verification Code') }"
                      placeholder="Change Verification Code">
                    <span v-show="errors.has('form-4.Verification Code')" class="help text-danger">{{ errors.first('form-4.Verification Code') }}</span>
                  </p>
                </div>

              </section>
              <footer class="modal-card-foot" style="padding-left:542px">
                <button class="button is-info" type="submit">Update</button>
              </footer>
            </div>
          </form>
        </div>
        <b-modal :id="infoModal.id" :title="infoModal.title" ok-only @hide="resetInfoModal" size="lg">
          <template slot="default" slot-scope="{ hide }">
            <form @submit.prevent="validateForm5('form-5')" data-vv-scope="form-1">
              <b-row>
                <!-- <pre>{{ infoModal.content }}</pre> -->
                <b-col md="6" >  
                  <b-form-group label="Location Name" :label-cols="3"
                    >                  
                    <b-form-input v-on:keyup="clear1" type="text" v-model="customer.pickuplocationname" name="pickup location name" v-validate="'required|'" :class="{'input': true, 'text-danger': errors.has('form-1.pickup location name') }" placeholder="Enter Pickup Location Name">
                    </b-form-input>
                     <span style="text-align:left;" v-show="errors.has('form-1.pickup location name')" class="help text-danger">{{ errors.first('form-1.pickup location name') }}</span>
                  </b-form-group>
             
                  <b-form-group label="Location ID" :label-cols="3"
                    >   
                    <b-form-select v-model="customer.pickuplocationpincode" name="locationpincode" v-validate="'required'" :class="{'input': true, 'text-danger': errors.has('form-1.locationpincode') }">
                        <option :value="selected">--Select--</option>
                        <option v-for="state in states"  v-bind:value="state.locality_id">{{state.locality_name}}</option>
                    </b-form-select> 

                    
                    <span style="text-align:left;" v-show="errors.has('form-1.location pincode')" class="help text-danger">{{ errors.first('form-1.pickup location code') }}</span>        
                  </b-form-group>

                  <b-form-group label="State" :label-cols="3"
                    >                  
                  
                    <b-form-input  type="text" v-model="customer.pickuplocationstate" name="state" v-validate="'required|'" :class="{'input': true, 'text-danger': errors.has('form-1.state') }" placeholder="Enter  state">
                    </b-form-input>
                     <span style="text-align:left;" v-show="errors.has('form-1.state')" class="help text-danger">{{ errors.first('form-1.state') }}</span>   
                  </b-form-group>
                  
                  <b-form-group label="Address" :label-cols="3"
                    >                  
                     <b-form-textarea class="textarea" id="" v-model="customer.pickuplocationaddress" name="address" v-validate="'required'" :class="{'input': true, 'text-danger': errors.has('form-1.address') }" placeholder="Enter Address"></b-form-textarea>
                      <small v-if='pickuplocationaddress' class="error">please enter pickuplocation address</small> 
                      <span style="text-align:left;" v-show="errors.has('form-1.address')" class="help text-danger">{{ errors.first('form-1.address') }}</span>  
                  </b-form-group>

                  <b-form-group label="Landmark" :label-cols="3"
                    >                  
                    <b-form-input class="input" type="text" v-model="customer.pickuplocationlandmark" name="landmark" v-validate="'required|alpha_spaces'" :class="{'input': true, 'text-danger': errors.has('form-1.landmark') }" placeholder="Enter Landmark Name">
                   </b-form-input>
                    <span style="text-align:left;" v-show="errors.has('form-1.landmark')" class="help text-danger">{{ errors.first('form-1.landmark') }}</span>
                  </b-form-group>

                  <b-form-group label="POC Mobile Number" :label-cols="3"
                    >                  
                    <b-form-input class="input" type="text" id="mobilenumber" v-model="customer.pocmobilenumber" name="poc mobile number" maxlength="10" v-validate="'required|digits:10'" :class="{'input': true, 'text-danger': errors.has('form-1.poc mobile number') }" placeholder="Enter POC Mobile Number">
                   </b-form-input>
                    <span style="text-align:left;" v-show="errors.has('form-1.poc mobile number')" class="help text-danger">{{ errors.first('form-1.poc mobile number') }}</span>
                  </b-form-group>
                 
                  <b-form-group label="Verification Code" :label-cols="3"
                    >                  
                    <b-form-input class="input" type="text" v-model="customer.verificationcode" name="verification code" v-validate="'required'" :class="{'input': true, 'text-danger': errors.has('form-1.verification code') }" placeholder="Enter Verification Code">
                   </b-form-input>
                     <span style="text-align:left;" v-show="errors.has('form-1.verification code')" class="help text-danger">{{ errors.first('form-1.verification code') }}</span>
                  </b-form-group>

                  <b-form-group label="Latitude" :label-cols="3"
                    >                  
                    <b-form-input class="input" type="text" v-model="customer.latitude" name="latitude" v-validate="'decimal'" :class="{'input': true, 'text-danger': errors.has('form-1.latitude') }" placeholder="Enter Latitude">
                    </b-form-input>
                    <span style="text-align:left;" v-show="errors.has('form-1.latitude')" class="help text-danger">{{ errors.first('form-1.latitude') }}</span>
                  </b-form-group>
                </b-col>  
                <b-col md="6" >
                 
                  <b-form-group label="Location Code" :label-cols="3"
                    >                  
                    <b-form-input class="input" type="text" v-model="customer.pickuplocationcode" name="pickup location code" v-validate="'required|alpha_num'" :class="{'input': true, 'text-danger': errors.has('form-1.pickup location code') }" placeholder="Enter Pickup Location Code">
                    </b-form-input>
                    <span style="text-align:left;" v-show="errors.has('form-1.pickup location code')" class="help text-danger">{{ errors.first('form-1.pickup location code') }}</span>
                  </b-form-group>

                  <b-form-group label="Location Type" :label-cols="3"
                    >    
                     <input type="text" readonly='' name="pickuplocationtype" id="pickuplocationtype" value="P2P" class="form-control input">               
                   <!--  <b-form-select name="location type" v-model="customer.pickuplocationtype" v-validate="'required'" :class="{'input': true, 'text-danger': errors.has('form-1.location type') }" style="margin-left:-0px;">
                      <option :value="selected">--Select--</option>
                      <option value="p2p">P2P</option>
                      <option value="p2phub">P2P Hub</option>
                    </b-form-select> -->
                    
                  </b-form-group>

                  <b-form-group label="City" :label-cols="3"
                    >                  
                  <b-form-input class="input" type="text" v-model="customer.pickuplocationcity" name="city" v-validate="'required|alpha_spaces'" :class="{'input': true, 'text-danger': errors.has('form-1.city') }" placeholder="Enter City Name">
                  </b-form-input>
                    <span style="text-align:left;" v-show="errors.has('form-1.city')" class="help text-danger">{{ errors.first('form-1.city') }}</span>
                  </b-form-group>

                  <b-form-group label="Street" :label-cols="3"
                    >                  
                  <b-form-input class="input" type="text" v-model="customer.pickuplocationstreet" name="street" v-validate="'required'" :class="{'input': true, 'text-danger': errors.has('form-1.street') }" placeholder="Enter Street Name">
                 </b-form-input>
                   <span style="text-align:left;" v-show="errors.has('form-1.street')" class="help text-danger">{{ errors.first('form-1.street') }}</span>
                  </b-form-group>

                  <b-form-group label="POC Name" :label-cols="3"
                    >                  
                   <b-form-input class="input" type="text" v-model="customer.pocname" name="poc name" v-validate="'required|'" :class="{'input': true, 'text-danger': errors.has('form-1.poc name') }" placeholder="Enter POC Name">
                   </b-form-input>
                   <span style="text-align:left;" v-show="errors.has('form-1.poc name')" class="help text-danger">{{ errors.first('form-1.poc name') }}</span>
                  </b-form-group>

                  <b-form-group label="POC Alt Mobile Number" :label-cols="3"
                    >                  
                  <b-form-input class="input" type="text" v-model="customer.pickuplocationpocmobilenoalt" name="pickuplocationpocmobilenoalt" maxlength="10" placeholder="Enter Pickup Location POC Alternate Mobile No">
                  </b-form-input>
                   <span style="text-align:left;" v-show="errors.has('form-1.poc name')" class="help text-danger">{{ errors.first('form-1.poc name') }}</span>
                  </b-form-group>

                  <b-form-group label="Vendor Code" :label-cols="3"
                    >                  
                  <b-form-input class="input" type="text" v-model="customer.clientvendorcode" name="client vendor code" v-validate="'required'" :class="{'input': true, 'text-danger': errors.has('form-1.client vendor code') }" placeholder="Enter Client Vendor Code">
                   </b-form-input>
                   <span style="text-align:left;" v-show="errors.has('form-1.client vendor code')" class="help text-danger">{{ errors.first('form-1.client vendor code') }}</span>
                  </b-form-group>

                  <b-form-group label="Longitude" :label-cols="3"
                    >                  
                  <b-form-input class="input" type="text" v-model="customer.longitude" name="longitude" v-validate="'decimal'" :class="{'input': true, 'text-danger': errors.has('form-1.longitude') }" placeholder="Enter Longitude">
                   </b-form-input>
                    <span style="text-align:left;" v-show="errors.has('form-1.longitude')" class="help text-danger">{{ errors.first('form-1.longitude') }}</span>
                  </b-form-group>     

                     <b-form-group label="IsActive" :label-cols="3"
                    >                  
                  <b-form-select name="isactive" v-model="customer.isactive" v-validate="'required'" :class="{'input': true, 'text-danger': errors.has('form-1.isactive') }">
                    <option :value="selected">--Select--</option>
                    <option value="1">Active</option>
                    <option value="0">InActive</option>
                  </b-form-select>
                  <span style="text-align:left;" v-show="errors.has('form-1.isactive')" class="help text-danger">{{ errors.first('form-1.isactive') }}</span>
                  </b-form-group>             
                </b-col>  
              </b-row>
              <div slot="footer" class="text-right">
                <b-button type="submit" class="mr-2" size="md" variant="primary"> Submit</b-button>
                <b-button type="button" size="md" variant="danger" @click="hide">Cancel</b-button>
              </div>             
            </form>
             
          </template>
          <template slot="modal-footer" slot-scope="{ hide }">
            <!-- Emulate built in modal footer ok and cancel button actions -->
            <b-button size="sm" style="display:none">
              Cancel
            </b-button>
            <!-- Button with custom close trigger value -->
          </template>
        </b-modal> 
      </b-col>
    </b-row>
  </div>
</template>

<script>
import CONSTANTS from '@/utils/constants'
import Utils from '@/utils'
import Vue from 'vue'
export default {
  name: 'pickuplocation', 
  data: function() {
    return {
        name: 'pickuplocation',
        isBusy: false,
        breadcrumbs: [{
          text: 'Dashboard',
          href: '/dashboard'
        },{
          text: 'Pickup Location',
          active: true
        }],
        data: [],
        clientdata: [],
        noofpages:'',
        add: true,
        selected:null,
        seen: true,
        customerSearch: {},
        search: true,
        longitude: '',
        latitude:'',      
        pickuplocationaddress:'',
        verificationCodeToggleInfo: false,
        customer: {
          pickuplocationcountry: 'Dubai'
        },
        items:[],
        states: [],
        fields: [
         { key: 'pickuplocationmasterid', label: 'id', sortable: true, sortDirection: 'desc' },
            { key: 'pickuplocationname', label: 'Name', sortable: true,  },
            { key: 'pickuplocationaddress', label: 'Address', sortable: true},          
            { key: 'pickuplocationstate', label: 'State', sortable: true },    
            { key: 'pickuplocationcity', label: 'City', sortable: true },
            { key: 'pickuplocationtype', label: ' Type' , sortable: true},
            { key: 'isactive', label: 'Isactive' },
            { key: 'show_details', label: 'Action' }
             // { key: 'pickuplocationpincode', label: 'Code', sortable: true},
             //    { key: 'pickuplocationmasterid', label: 'masterid', sortable: true},           
        ],
        bordered: true,
        totalRows: 0,
        pageNum:1,
        currentPage: 1,
        perPage:  20,
        searching:'',
        pageOptions: [5, 10, 15],
        sortBy: "true",
        sortDesc: true,
        sortDirection: 'desc',
        filter: null,
        infoModal: {
          id: 'info-modal',
          title: '',
          content: ''
        }
    }
  },
  created: function() {
    this.displaydata(this.pageNum);
   // this.getlocations();
    //this.displayclient();
  },
  computed: {
      sortOptions() {
        // Create an options list from our fields
        return this.fields
          .filter(f => f.sortable)
          .map(f => {
            return { text: f.label, value: f.key }
          })
      }
    },
  methods: {
        info(item, index, button) {
        this.infoModal.title = `Edit Pickup Location`;
        this.infoModal.content = JSON.stringify(item, null, 2);
        this.customer= item;
        if(item.pickuplonglat.length >0){
          var nameArr = item.pickuplonglat.split(',');
         this.customer.latitude=nameArr[0];
        this.customer.longitude=nameArr[1]; 
        }else{
        this.customer.latitude='';
        this.customer.longitude='';  
        }
        this.$root.$emit('bv::show::modal', this.infoModal.id, button)
      },
      resetInfoModal() {
        this.infoModal.title = '';
        this.infoModal.content = '';
        this.customer = {};
        this.errors.clear('form-5')
      },
      onFiltered(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
        this.totalRows = filteredItems.length
        this.currentPage = 1
      },
    getlocations: function(){
      this.$http
        .post(`${CONSTANTS.MIGRATION_API_URL}/locationlist`)
        .then(result => {
          this.states = result.body;
         // console.log('this.locations',this.states);
        })
        .catch(ex => {
          alert(ex);
        });
    },
    validateForm(scope) {
      this.customer.pickuplonglat =  this.latitude+ ',' + this.longitude
      this.$validator.validateAll(scope).then(result => {
        if (result) {
          this.createPickupLocation()
        }
      })
    },
    clear1: function() {},
    useradd: function() {
      //this.customer = {};
      this.subtitle='Add Delivery Agent info';
      this.errors.clear("form-1");
      var search1 = document.getElementById("searchpickup");
      search1.style.display = "none";
      this.seen = !this.seen;
      // var allocatepin = document.getElementById('allocatepin')
      // allocatepin.style.display = 'none'
      var adduser = document.getElementById("adduser");
      adduser.style.display = "block";
    
    },
    // searchrecord:function()
    // {
    //   alert(" i m in search");
    // },
    clearrecord:function()
    {
      
      this.searching="";
      this.displaydata(1);
       this.$router.push('/pickuplocation_mr');
    },
    refresh:function() {
       this.subtitle='Delivery Agent info';
      var search1 = document.getElementById("searchpickup");
      search1.style.display = "none";
      this.seen = !this.seen;
      // var allocatepin = document.getElementById('allocatepin')
      // allocatepin.style.display = 'none'
      var adduser = document.getElementById("adduser");
      adduser.style.display = "none";
      this.searchclear();
    },
    searchpickup: function() {
      this.subtitle='Search Delivery Agent info';

      var search1 = document.getElementById("searchpickup");
      search1.style.display = "block";
      this.seen = !this.seen;
      // var allocatepin = document.getElementById('allocatepin')
      // allocatepin.style.display = 'none'
      var adduser = document.getElementById("adduser");
      adduser.style.display = "none";
      this.searchclear();
    },
    searchclear: function() {
      this.customerSearch = {}
      this.errors.clear('form-2')
    },
    chkmobileVal() {
      var chkValidate = true;
     // var chknumb = /^[789]{1}\d{9}$/
      var chknumb = /^((\+[1-9]{1,4}[ \-]*)|(\([0-9]{2,3}\)[ \-]*)|([0-9]{2,4})[ \-]*)*?[0-9]{3,4}?[ \-]*[0-9]{3,4}?$/;
      var mobilenumber = document.getElementById("mobilenumber").value
      if (mobilenumber.trim() === '0000000000' || mobilenumber.trim().length < 10) {
        chkValidate = false
        return false
      } else if (mobilenumber.trim() != "" && !(mobilenumber.trim().match(chknumb))) {
        chkValidate = false
        return false
      }
      return chkValidate = chkValidate;
    },
    createPickupLocation: function() {
      var chkmobileVal = this.chkmobileVal()
      this.customer.clientid=document.getElementById("clientid").value;
      this.customer.pickuplocationtype=document.getElementById("pickuplocationtype").value;
      if (chkmobileVal) {
        var userdata = localStorage.getItem('userData')
        var userInfo = JSON.parse(userdata)
        this.customer.lastmodifiedby = `${userInfo.sysemailid}`
        this.$validator.validateAll().then(result => {
          if (this.customer.pickuplocationtype === 'p2phub') {}
          if (result) {
            this.$http
              .post(
                `${CONSTANTS.MIGRATION_API_URL}/pickuplocationmasteradd`,
                this.customer
              )
              .then(result => {
            //    console.log('Added successfully')
                // alert('Added successfully')
                  this.$fire({
                  text:"Added Successfully",
                  type: "success",
                  timer: 30000
                }); 
               
                var adduser = document.getElementById("adduser");
               adduser.style.display = "none";
               this.clear();
                // this.customer = {}
                // this.longitude = ''
                // this.latitude = ''
                // this.customer.pickuplocationcountry = 'dubai'
                this.displaydata(this.pageNum);
                 this.$router.push('/pickuplocation_mr');
              })
              .catch(ex => {
                console.log('error')
                
              })
            return
          } else {}
        })
      } else {
         // console.log('Please enter valid mobile number error')
        // alert('Please enter valid mobile number error');
         this.$fire({
                  text:"Please enter valid mobile number",
                  type: "error",
                  timer: 30000
                }); 
      }
    },
    getPickupLocationById: function() {
      var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
      if (this.$route.params.id) {
        const obj = {
          lastmodifiedby: `${userInfo.sysemailid}`,
          pickuplocationmasterid: this.$route.params.id
        }
        this.$http
          .post(`${CONSTANTS.MIGRATION_API_URL}/pickuplocationmasterget`, obj)
          .then(result => {
            this.customer = result.body[0]
          })
          .catch(ex => {
            console.log('error', ex)
          })
      }
    },
    validateForm2: function(scope) {
      //this.displaydata(JSON.stringify(this.customerSearch))
      this.displaydata(this.pageNum)
    },
    // displaydata: function(serchData) {
      displaydata: function(pagee) {
        // alert("hiiiiiiii"+pagee);
      this.isBusy = true;
      // const customerGetAllobj = serchData || {}
      const customerGetAllobj = {
          limit: "20",
          page_no: pagee,
          searchFilter:this.searching,
        }
      this.$http
        .post(
          `${CONSTANTS.MIGRATION_API_URL}/pickuplocationmastergetall`,
          customerGetAllobj
        )
        .then(result => {
          if (
            (result.body[0].returnmsg &&
              result.body[0].returnmsg === 'UnSuccessful') ||
            result.body[0].returnmsg === 'No Records Founnd'
          ) {
            this.data = result.body;
            this.items  = result.body;
            this.totalRows = result.body[0].totalrecords[0].count;
            this.isBusy = !this.isBusy;
          // console.log('Result not found error');
          } else {
            
            
          if (result.body[0].pickuplocationlist.length > 0) {
            var results=[];
            results =result.body[0].pickuplocationlist;

            var searchResults=[];
            results.forEach((element) => { 
                      
              if(element.pickuplocationtype=='p2p'){

               
                 
              }
              searchResults.push(element);
            }); 

            this.data = searchResults;
            this.items  = searchResults;

            this.totalRows =result.body[0].totalrecords[0].count;

            this.noofpages=parseInt(this.totalRows)/20;
           this.noofpages=Math.round( this.noofpages);
           // alert( this.noofpages);
            this.isBusy = !this.isBusy;           
          }

          }
        })
        .catch(ex => {
          console.log('error', ex)
        })
    },
    edituser: function(value) {
      var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
      this.errors.clear('form-1')
      this.seen = true
      this.customer = JSON.parse(JSON.stringify(value))
      var latLogArray = value.pickuplonglat.split(',')
      this.longitude = latLogArray[0] || 0
      this.latitude = latLogArray[1] || 0
    },
    clear: function() {
      this.customer = {}
      this.errors.clear('form-1')
      this.longitude = ''
      this.latitude = ''
      this.customer.pickuplocationcountry = 'dubai'
    },
    // displayclient: function() {
    //   this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/clientmastergetall`)
    //     .then(result => {
    //       this.clientdata = result.body
    //     })
    //     .catch(ex => {
    //        console.log('error');
    //     })
    // },
    validateForm4(scope) {
      this.$validator.validateAll(scope).then((result) => {
        if (result) {
          this.changeVerificationCode()
        }
      })
    },
    changeVerificationCode: function() {
        var result = []
        var userdata = localStorage.getItem('userData')
        var userInfo = JSON.parse(userdata)
     
    },
      clickCallback (pageNum)
       {
        //alert(" i m in pagination task");
      //alert(pageNum)
      this.displaydata(pageNum);
    },
    changeVerificationCodeModal: function(value) {
      this.customer.verificationcode = value.verificationcode
      this.verificationCodeToggleInfo = !this.verificationCodeToggleInfo
    },
    CloseVerificationCodeModal: function() {
      this.customer = {}
      this.verificationCodeToggleInfo = !this.verificationCodeToggleInfo
    }
  },
  filters: {
    datechange: function(value) {
       
      if(value==null){
       return '-';
      }else{
        var d = new Date(value)
        var curr_date = (d.getDate() < 10 ? '0' : '') + d.getDate();
        var month = d.getMonth() + 1;
        var curr_year = d.getFullYear();
        var curr_month = month < 10 ? '0' + month : '' + month;
        var hours = d.getHours();
        var minutes = d.getMinutes();
        var ampm = hours >= 12 ? 'pm' : 'am';
        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        minutes = minutes < 10 ? '0'+minutes : minutes;
        var strTime = hours + ':' + minutes + ' ' + ampm;
        return curr_date + '-' + curr_month + '-' + curr_year+'  '+ " " + strTime;

      }
    }
  }
}
</script>

<style>
  /* IE fix */
  #card-chart-01, #card-chart-02 {
    width: 100% !important;
  }

 /* Pagination links */
.pagination a {
  color: black;
  float: left;
  padding: 8px 16px;
  text-decoration: none;
  transition: background-color .3s;
  /* border: 1px solid #ddd;*/ /* Gray */
}

/* Style the active/current link */
/*.pagination a.active {
   
  
}*/
.page-item.active {
  background-color: #87CEEB;
    color: white;
}
/* Add a grey background color on mouse-over */
.pagination a:hover:not(.active) {background-color: #ddd;}

</style>

